import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "calendar-day__alert-container" }
const _hoisted_2 = { class: "calendar-day__alert-title" }
const _hoisted_3 = { class: "calendar-day__alert-text" }
const _hoisted_4 = { class: "calendar-day__modal-content" }
const _hoisted_5 = { class: "calendar-day__alert-text" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "calendar-day__alert-partition-line" }
const _hoisted_8 = { class: "calendar-day__alert-container" }
const _hoisted_9 = { class: "calendar-day__alert-title" }
const _hoisted_10 = { class: "calendar-day__alert-text" }
const _hoisted_11 = { class: "calendar-day__modal-content" }
const _hoisted_12 = { class: "calendar-day__alert-text" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "calendar-day__events" }
const _hoisted_15 = ["draggable", "onDragstart"]
const _hoisted_16 = { class: "calendar-day__modal" }
const _hoisted_17 = { class: "calendar-day__modal-title" }
const _hoisted_18 = { class: "calendar-day__modal-content" }
const _hoisted_19 = ["draggable", "onDragstart"]

import { computed, ref, onMounted, onUnmounted } from 'vue';
import { useOrderCalendarStore } from '../pages/orderCalendarStore';
import { storeToRefs } from 'pinia';
import { CalendarOrder } from '../domains/entities/CalendarOrder';
import { CalendarOrderService } from '../domains/services/CalendarOrderService';
import { IDate } from '@/coreDomainsModule/date';
import { DateService } from '@/coreDomainsModule/services/dateService';
import SvgLoader from '@/utils/SvgLoader.vue';
import { i18n } from '@/i18n';
import { OrderRepository } from '@/coreInfrastructureModule/Repositories/OrderRepository';


export default /*@__PURE__*/_defineComponent({
  __name: 'CalendarDay',
  props: {
    date: {},
    orders: {},
    disabled: { type: Boolean },
    isWeekend: { type: Boolean }
  },
  setup(__props: any) {

const t = i18n.t;

const orderRepository = new OrderRepository();
const store = useOrderCalendarStore();
const { state } = storeToRefs(store);
const { setDraggingOrder, moveDraggingOrder, isValidBulkOrderRules, isValidDailyDeliveryLimit, setModalInfo } = store;

/**
 * カレンダーの日付と発注を表示するコンポーネントのプロパティ
 * @property day - 表示する日付
 * @property events - その日のイベントのリスト
 */
const props = __props;

/**
 * 「他N件」をクリックしたときに呼び出される関数
 * さらに多くのイベントの詳細を表示するためのハンドラ
 */
const showMore = () => {
  if (state.value.dateOpeningOtherOrderModal === undefined) {
    state.value.dateOpeningOtherOrderModal = props.date;
  } else {
    if (!DateService.equalYearMonthDayInfo(state.value.dateOpeningOtherOrderModal, props.date)) {
      state.value.dateOpeningOtherOrderModal = props.date;
    } else {
      state.value.dateOpeningOtherOrderModal = undefined;
    }
  }
};

/**
 * モーダルの位置を微調整する関数
 */
const tweakModalPosition = () => {
  // モーダルとトリガー要素の取得
  const modal = document.querySelector('.calendar-day__modal');
  const trigger = document.querySelector('.calendar-day__event--more');

  if (!modal || !trigger) {
    console.error('モーダルまたはトリガー要素が見つかりません。');
    return;
  }

  // ElementからHTMLElementにキャスト
  if (!(trigger instanceof HTMLElement) || !(modal instanceof HTMLElement)) {
    console.error('トリガー要素またはモーダルがHTMLElementではありません。');
    return;
  }

  // トリガー要素の位置とサイズを取得
  const triggerRect = trigger.getBoundingClientRect();

  // モーダルが非表示状態でサイズを取得できない場合、一時的に表示（visibilityを使って見えなくする）
  modal.style.visibility = 'hidden';
  modal.style.display = 'block';
  const modalWidth = modal.offsetWidth;
  const modalHeight = modal.offsetHeight;
  modal.style.visibility = ''; // visibility設定をクリア
  modal.style.display = 'none'; // display設定をもとに戻す

  // モーダルを表示する位置を計算
  const leftPosition = triggerRect.right; // トリガーの右端
  const topPosition = triggerRect.top + window.scrollY + triggerRect.height / 2 - modalHeight / 2; // 垂直中央揃え

  // モーダルにスタイルを適用
  modal.style.position = 'absolute';
  modal.style.left = `${leftPosition}px`;
  modal.style.top = `${topPosition}px`;

  // モーダルを表示
  modal.style.display = 'block';
};

const isShowModal = computed(() => {
  if (state.value.dateOpeningOtherOrderModal === undefined) {
    return false;
  }
  return DateService.equalYearMonthDayInfo(state.value.dateOpeningOtherOrderModal, props.date);
});

/**
 * ドラッグ操作が開始されたときに呼び出されるハンドラ
 * ドラッグされる要素の情報をデータ転送オブジェクトに設定する
 * @param event - イベントオブジェクト
 * @param order - ドラッグされる発注情報
 */
const handleDragStart = (event: DragEvent, order: CalendarOrder) => {
  setDraggingOrder(order);
  // DOMを不可視にする
  // 瞬時に不可視にすると、ドラッグ操作が開始された瞬間に要素が消えるため、少し遅らせる
  setTimeout(() => {
    if (event.target instanceof HTMLElement) {
      event.target.style.opacity = '0';
    }
  }, 1);
};

/**
 * ドラッグ操作が終了したときに呼び出されるハンドラ
 * ドラッグされる要素の表示を元に戻す
 * @param event - イベントオブジェクト
 */
const handleDragEnd = (event: Event) => {
  if (event.target instanceof HTMLElement) {
    // DOMを可視に戻す
    event.target.style.opacity = '1';
  }
};

/**
 * ドロップされた時に呼び出されるハンドラ
 */
const handleDrop = async () => {
  await moveDraggingOrder(props.date, orderRepository);
};

/**
 * 表示される発注情報の文言を取得する
 * @param order - 発注情報
 */
const getDisplayOrder = (order: CalendarOrder) => {
  return `${order.businessName} ${order.amount.addComma()}${order.unit ?? ''}`;
};

// 表示するイベントの計算されたプロパティ。最大3つまで。
const orderToShow = computed(() => props.orders.slice(0, 3));

// 「他N件」の計算されたプロパティ。3つを超えるイベントの数。
const remainingOrders = computed(() => Math.max(props.orders.length - 3, 0));

/**
 * アラートを左方向に展開するかを返す。木曜日と金曜日と土曜日はTrueを返す。
 */
const isAlertLeft = computed(() => {
  const dateObject = DateService.convertIDateToDate(props.date);
  if (dateObject.getDay() === 4 || dateObject.getDay() === 5 || dateObject.getDay() === 6) {
    return true;
  }
  return false;
});

const isShowDeliveryLimitAlert = computed(() => {
  return !props.disabled && !isValidDailyDeliveryLimit(props.date) && !isCheckDeliveryLimit.value;
});

const isShowBulkOrderRulesAlert = computed(() => {
  return !props.disabled && !isValidBulkOrderRules(props.date) && !isCheckBulkOrderRules.value;
});

const isDragging = ref(false);
const modalPosition = ref({ x: 0, y: 0 });

const isShowAlertModal = ref(false);
const isCheckDeliveryLimit = ref(false);
const isCheckBulkOrderRules = ref(false);
const isCheckBoxTrueDeliveryLimit = ref(false);
const isCheckBoxTrueBulkOrderRules = ref(false);

/**
 *　モーダルの現在位置を更新するための関数
 * @param x - モーダルの新しい位置
 * @param y　- モーダルの新しい位置
 */
const updateModalPosition = (x: number, y: number) => {
  modalPosition.value.x = x;
  modalPosition.value.y = y;
};

/**
 * モーダルをドラッグするための関数
 * @param event - マウスイベント
 */
const startDrag = (event: MouseEvent) => {
  isDragging.value = true;
  const modal = event.target as HTMLElement;
  const offsetX = event.clientX - modal.getBoundingClientRect().left;
  const offsetY = event.clientY - modal.getBoundingClientRect().top;

  /**
   * マウスが移動したときに呼び出される関数
   * @param moveEvent - マウスイベント
   */
  const handleMouseMove = (moveEvent: MouseEvent) => {
    if (isDragging.value) {
      const x = moveEvent.clientX - offsetX;
      const y = moveEvent.clientY - offsetY;
      updateModalPosition(x, y);
    }
  };

  /**
   * マウスが離されたときに呼び出される関数
   */
  const handleMouseUp = () => {
    window.removeEventListener('mousemove', handleMouseMove);
    window.removeEventListener('mouseup', handleMouseUp);
    isDragging.value = false;
  };

  window.addEventListener('mousemove', handleMouseMove);
  window.addEventListener('mouseup', handleMouseUp);
};

/**
 * 日付がクリックされたときに呼び出されるハンドラ
 */
const clickDay = () => {
  if (props.orders.length === 0) return;
  // 外部要因でモーダルが閉じた場合に再度開くための対応 （isOpenがtrueの場合、true -> trueのため変更が検知されない）
  if (state.value.modalInfo.isOpen === true) {
    setModalInfo(false, undefined);
  }
  setModalInfo(true, props.date);
};

onMounted(() => {
  const modalElement = document.querySelector('.calendar-day__modal');
  modalElement?.addEventListener('mousedown', startDrag as EventListener);
});

onUnmounted(() => {
  const modalElement = document.querySelector('.calendar-day__modal');
  modalElement?.removeEventListener('mousedown', startDrag as EventListener);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`calendar-day ${_ctx.disabled ? 'calendar-day--disabled' : ''}`),
    onDragover: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
    onDrop: handleDrop
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(`calendar-day__date ${_ctx.isWeekend ? 'calendar-day__date--weekend' : ''} ${
        _ctx.orders.length === 0 ? 'calendar-day__date--no-pointer' : ''
      }`),
      onClick: clickDay
    }, _toDisplayString(_ctx.date.day), 3),
    _withDirectives(_createVNode(SvgLoader, {
      class: "calendar-day__alert-icon",
      name: "calendarAlert",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (isShowAlertModal.value = !isShowAlertModal.value))
    }, null, 512), [
      [_vShow, isShowDeliveryLimitAlert.value || isShowBulkOrderRulesAlert.value]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(`calendar-day__alert-modal ${isAlertLeft.value ? 'calendar-day__alert-modal--left' : ''}`)
    }, [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(t)('まとめ発注アラート')), 1),
        _createElementVNode("p", _hoisted_3, [
          _createTextVNode(_toDisplayString(_unref(t)('仕入先との発注ルールに則っていません。')), 1),
          _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
          _createTextVNode(" " + _toDisplayString(_unref(t)('納期と数量の調整をお願いします。')), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.orders, (order, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(`calendar-day__event ${_unref(CalendarOrderService).isChangeableCrossDate(order) ? 'calendar-day__event--draggable' : ''}`)
            }, _toDisplayString(getDisplayOrder(order)), 3))
          }), 128))
        ]),
        _createElementVNode("p", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isCheckBoxTrueBulkOrderRules).value = $event)),
            class: "calendar-day__alert-checkbox",
            type: "checkbox"
          }, null, 512), [
            [_vModelCheckbox, isCheckBoxTrueBulkOrderRules.value]
          ]),
          _createTextVNode(_toDisplayString(_unref(t)('仕入先から了承受領済み')), 1)
        ]),
        _createElementVNode("button", {
          class: _normalizeClass(`calendar-day__alert-button`),
          disabled: !isCheckBoxTrueBulkOrderRules.value,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (isCheckBulkOrderRules.value = true))
        }, _toDisplayString(_unref(t)('アラートを取り消す')), 9, _hoisted_6)
      ], 512), [
        [_vShow, isShowBulkOrderRulesAlert.value]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_7, null, 512), [
        [_vShow, isShowDeliveryLimitAlert.value && isShowBulkOrderRulesAlert.value]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_8, [
        _createElementVNode("h1", _hoisted_9, _toDisplayString(_unref(t)('受入上限オーバー')), 1),
        _createElementVNode("p", _hoisted_10, [
          _createTextVNode(_toDisplayString(_unref(t)('1日の受入上限を超過しています。')), 1),
          _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
          _createTextVNode(" " + _toDisplayString(_unref(t)('納期の調整をお願いします。')), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.orders, (order, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(`calendar-day__event ${_unref(CalendarOrderService).isChangeableCrossDate(order) ? 'calendar-day__event--draggable' : ''}`)
            }, _toDisplayString(getDisplayOrder(order)), 3))
          }), 128))
        ]),
        _createElementVNode("p", _hoisted_12, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isCheckBoxTrueDeliveryLimit).value = $event)),
            class: "calendar-day__alert-checkbox",
            type: "checkbox"
          }, null, 512), [
            [_vModelCheckbox, isCheckBoxTrueDeliveryLimit.value]
          ]),
          _createTextVNode(_toDisplayString(_unref(t)('倉庫から超過納入了承を受領済み')), 1)
        ]),
        _createElementVNode("button", {
          class: "calendar-day__alert-button",
          disabled: !isCheckBoxTrueDeliveryLimit.value,
          onClick: _cache[4] || (_cache[4] = ($event: any) => (isCheckDeliveryLimit.value = true))
        }, _toDisplayString(_unref(t)('アラートを取り消す')), 9, _hoisted_13)
      ], 512), [
        [_vShow, isShowDeliveryLimitAlert.value]
      ])
    ], 2), [
      [_vShow, isShowAlertModal.value && (isShowDeliveryLimitAlert.value || isShowBulkOrderRulesAlert.value)]
    ]),
    _createElementVNode("div", _hoisted_14, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderToShow.value, (order, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(`calendar-day__event ${_unref(CalendarOrderService).isChangeableCrossDate(order) ? 'calendar-day__event--draggable' : ''} ${
          index !== 2 ? 'calendar-day__event--not-last' : ''
        }`),
          draggable: _unref(CalendarOrderService).isChangeableCrossDate(order),
          onDragstart: (e) => handleDragStart(e, order),
          onDragend: handleDragEnd
        }, _toDisplayString(getDisplayOrder(order)), 43, _hoisted_15))
      }), 128)),
      (remainingOrders.value > 0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "calendar-day__event--more",
            onClick: showMore
          }, [
            _createTextVNode(_toDisplayString(_unref(t)('他')) + _toDisplayString(remainingOrders.value) + _toDisplayString(_unref(t)('件')) + " ", 1),
            _withDirectives(_createElementVNode("div", _hoisted_16, [
              _createElementVNode("h2", _hoisted_17, _toDisplayString(_unref(t)('全ての発注', { month: _ctx.date.month, day: _ctx.date.day })), 1),
              _createElementVNode("div", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.orders, (order, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: _normalizeClass(`calendar-day__event ${_unref(CalendarOrderService).isChangeableCrossDate(order) ? 'calendar-day__event--draggable' : ''}`),
                    draggable: _unref(CalendarOrderService).isChangeableCrossDate(order),
                    onDragstart: (e) => handleDragStart(e, order),
                    onDragend: handleDragEnd
                  }, _toDisplayString(getDisplayOrder(order)), 43, _hoisted_19))
                }), 128))
              ])
            ], 512), [
              [_vShow, isShowModal.value]
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 34))
}
}

})